"use client"

import { useState } from "react"
import "./ScopingFAQ.css"

const faqData = [
  {
    question: "What is scoping session?",
    answer:
      "A Scoping Session is an initial session ran with our team of experts from developers to project managers that intends to help you clarify some of your ideas and transform them into a business concept, to ensure a solid start as you build your product.",
  },
  {
    question: "What is the main benefits of scoping session?",
    answer:
      "Because you have planned ahead, a scope session will ensure you a clear roadmap of what to do, helps you identify the resources needed from the start, avoid extra costs and delays, as well better business forecasts.",
  },
  
]

const ScopingFAQ = () => {
  const [openItems, setOpenItems] = useState([])

  const toggleItem = (index) => {
    setOpenItems((prev) => (prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]))
  }

  return (
    <div className="faq-container" id="faq">
      <div className="container">
      <div className="faq-wrapper">
        {/* Header */}
        <div className="header-section968">
          <h1 className="main-title">EVERYTHING YOU NEED TO KNOW ABOUT OUR</h1>
          <h2 className="sub-title"> SCOPING SESSION SERVICE</h2>
        </div>

        <div className="content-grid">
          {/* Left Sidebar */}
          <div className="sidebar">
            <div className="sidebar-image">
              <img src="/faq.webp?height=10&width=10" alt="FAQ Illustration" />
            </div>

            <div className="sidebar-content">
              <p className="sidebar-text">
                Browse the Frequently Asked Questions and get your answers. Or better yet - get in touch with our team
                and let's talk!
              </p>
              <button className="quote-button">GET A QUOTE</button>
            </div>
          </div>

          {/* FAQ Section */}
          <div className="faq-section">
            <div className="faq-list">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <div className="faq-question" onClick={() => toggleItem(index)}>
                    <p className="question-text">{faq.question}</p>
                    <div className="chevron-icon">
                      {openItems.includes(index) ? (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="18,15 12,9 6,15"></polyline>
                        </svg>
                      ) : (
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                        >
                          <polyline points="6,9 12,15 18,9"></polyline>
                        </svg>
                      )}
                    </div>
                  </div>
                  {openItems.includes(index) && (
                    <div className="faq-answer">
                      <p className="answer-text">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Scroll Indicator */}
            <div className="scroll-indicator">
              <div className="scroll-dot"></div>
              <div className="scroll-bar"></div>
              <div className="scroll-dot"></div>
            </div>
          </div>
        </div>

        {/* Bottom CTA Section */}
        <div className="cta-section">
          <div className="cta-content">
            <div className="cta-text">
              <h3 className="cta-title">STILL HAVE QUESTIONS?</h3>
              <p className="cta-description">
                Our team of business developers and project managers can help you to clarify any questions you have
                related. Feel free to chat with us anytime.
              </p>
            </div>
            <button className="call-button">BOOK A CALL</button>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}

export default ScopingFAQ;
